import { v4 as uuidv4 } from 'uuid'

import Table from '../../Table'
import { FROM_EXPO } from '../../constants'
import { IMessage } from '../../type'

export default function handleSalesmanshipKpiValues(responseData: any) {
  if (responseData?.salesmanshipKpiValues) {
    const answerMessage: IMessage = {
      id: uuidv4(),
      from: FROM_EXPO,
      content: <Table data={responseData.salesmanshipKpiValues} />,
    }

    return answerMessage
  }

  return null
}
